import {Component, OnInit} from '@angular/core';
import {DisplayedProduct, ModifierGroupInfo} from "app/models/menu.model";
import {ModifierGroupApiService} from 'app/services/menu-edit/modifier-group-api.service';
import {ActivatedRoute} from "@angular/router";
import {firstValueFrom, Observable} from "rxjs";
import {Select} from "@ngxs/store";
import {OrganizationsState} from "app/state-management/states/organizations.states";
import {Organization} from "app/models/organization.model";
import {
  ModifierGroupModalComponent, ModifierGroupModalData
} from "app/pages/menu-edit/modifier-group/modifier-group-modal/modifier-group-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {UntilDestroy} from "@ngneat/until-destroy";
import {
  OnCheckedModifierGroup
} from "app/pages/menu-edit/modifier-group/modifier-group-item/modifier-group-item.component";

@UntilDestroy()
@Component({
  selector: 'app-modifier-group',
  templateUrl: './modifier-group.component.html',
  styleUrls: ['./modifier-group.component.scss']
})
export class ModifierGroupComponent implements OnInit {
  selectedModifierGroupIds: Set<string> = new Set();
  modifierGroups: ModifierGroupInfo[];
  organization: Organization;
  modifiers: Map<string, DisplayedProduct>;
  loading: boolean;
  @Select(OrganizationsState.getSelectedOrganization) selectedOrganization$: Observable<Organization>;

  constructor(
    public activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private modifierGroupService: ModifierGroupApiService,
  ) {
  }

  async ngOnInit() {
    this.organization = await firstValueFrom(this.selectedOrganization$)

    const modifiers = await this.modifierGroupService.getModifierListAsync(this.organization.id);

    this.modifiers = modifiers.reduce((accumulator: Map<string, DisplayedProduct>, m: DisplayedProduct) => {
      accumulator.set(m.externalId, m);
      return accumulator;
    },
      new Map<string, DisplayedProduct>());
    this.modifierGroups = await this.modifierGroupService.getModifierGroupsAsync(this.organization.id);
  }

  onClickCreateModifierGroup(){
    this.dialog.open(
      ModifierGroupModalComponent, {
        data: {
          modifierGroup: {
            id: '',
            name: '',
            description: '',
            nameTranslations: {},
            descriptionTranslations: {},
            modifierProducts: [],
          } as ModifierGroupInfo,
          organization: this.organization,
          modifiers: this.modifiers,
        } as ModifierGroupModalData
      }
    ).afterClosed().subscribe(res => {
      if(!res){
        return;
      }
      const result = res as ModifierGroupInfo;
      this.modifierGroups.push(result);
    })
  }

  selectModifierGroupHandler(checkedInfo: OnCheckedModifierGroup){
    if(checkedInfo.checked && !this.selectedModifierGroupIds.has(checkedInfo.modifierGroupId)){
      this.selectedModifierGroupIds.add(checkedInfo.modifierGroupId);
    }

    if(!checkedInfo.checked && this.selectedModifierGroupIds.has(checkedInfo.modifierGroupId)){
      this.selectedModifierGroupIds.delete(checkedInfo.modifierGroupId);
    }
  }

  onLoadingHandler(arg: boolean) {
    this.loading = arg;
  }

  onDeleteHandler(modifierGroupId: string){
    this.modifierGroups = [...this.modifierGroups.filter(mg => mg.id !== modifierGroupId)];
  }

  async onApplyModifierGroup() {
    this.loading = true;
    var res = await this.modifierGroupService.applyModifierGroupsAsync(this.organization.id, [...this.selectedModifierGroupIds.values()])
    if(res == 'good'){
      alert('success');
    } else {
      alert('error');
    }
    this.loading = false;
  }
}
